import css from "./ItemLink.module.css";
import { Grade } from "~/types";
import { ItemGrade } from "./Grade";
import { GameVer, tturl, useRealm } from "~/util/Lang";
import { EntityTooltip } from "../site/Tooltip";
import { Link } from "react-router";
import { Icon } from "../ui/Icon";

export type ItemLinkData = {
  itemName: string;
  name: string;
  addName?: string;
  icon: string;
  crystalType?: string | null;
  gver?: GameVer;
};

const itemLinkColor = "#eab308";

export function getItemPath(props: { item: ItemLinkData }) {
  const item = props.item;
  const realm = useRealm();

  return tturl(
    { lang: realm.lang, game: item.gver ?? realm.game },
    `/items/${item.itemName}`
  );
}

export function ItemLink(props: {
  item: ItemLinkData;
  count?: number | null;
  enchant?: number | null;
  iconSize?: 16 | 24;
  showIcon?: boolean;
  isLink?: boolean;
}) {
  const { item, enchant } = props;
  const iconSize = props.iconSize ?? 16;
  const showIcon = props.showIcon ?? true;
  const gap = iconSize === 16 ? 3 : 9;
  const isLink = props.isLink ?? true;

  const linkContent = (
    <>
      {showIcon && (
        <span className={css.icon} style={{ marginRight: gap }}>
          <Icon
            icon={item.icon}
            size={iconSize}
            alt={`Icon Item ${item.name}`}
            game={item.gver}
          />
        </span>
      )}
      <span className={css.name}>
        {item.name}
        {item.addName && ` [${item.addName}]`}
        {item.crystalType && <ItemGrade grade={item.crystalType as Grade} />}
      </span>
    </>
  );

  return (
    <span className={css.wrapper}>
      {enchant !== 0 && enchant && (
        <span className={css.enchant}>+{enchant}</span>
      )}
      <EntityTooltip
        what={{ t: "item", uname: item.itemName }}
        gver={item.gver}
      >
        {({ setReference, getReferenceProps }) =>
          isLink ? (
            <Link
              ref={setReference}
              to={getItemPath({ item })}
              {...getReferenceProps()}
              className={css.link}
            >
              {linkContent}
            </Link>
          ) : (
            <span
              ref={setReference}
              {...getReferenceProps()}
              className={css.link}
              // style={{ color: itemLinkColor }}
            >
              {linkContent}
            </span>
          )
        }
      </EntityTooltip>{" "}
      {typeof props.count === "number" && props.count > 0 && (
        <span className={css.count}>x{props.count}</span>
      )}
    </span>
  );
}
